import { render } from "./Decommissioned.vue?vue&type=template&id=de606910"
import script from "./Decommissioned.vue?vue&type=script&lang=js"
export * from "./Decommissioned.vue?vue&type=script&lang=js"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__